function KpiCard({ icono: Icono, etiqueta, valor, ayuda }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <Icono
        size={24}
        className="text-emerald-600"
      />

      <p className="mt-5 text-sm text-slate-500">{etiqueta}</p>

      <p className="mt-1 text-2xl font-bold text-slate-900">
        {valor}
      </p>

      {ayuda}
    </div>
  )
}

export default KpiCard
